import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

import AddPaneltem from '../common/AddPaneltem';

import messages from '../../translation_hotkey_template';


class TabPanelAddItem extends Component {
  render() {
    let { height, width, label, onClick, intl } = this.props;

    if (label === 'Add') {
      label = intl.formatMessage( messages.label_add )
    }
    
    return (
      <AddPaneltem
        height={height} 
        width={width}
        label={label}
        onClick={onClick}
      />
    );
  }
}


export default injectIntl(TabPanelAddItem);
